import React, { FC } from 'react';
import clsx from 'clsx';
import styles from './Info.module.scss';

export const Info: FC<React.PropsWithChildren<{className?: string}>> = ({ children, className = '' }) => (
  <div className={clsx(className, styles.info)}>{children}</div>
);
